// extracted by mini-css-extract-plugin
export var address = "styles-module--address--6562d";
export var content = "styles-module--content--12199";
export var header = "styles-module--header--dacde";
export var link = "styles-module--link--bc5d9";
export var title = "styles-module--title--7e02a";